export default function SImproveText({ size = 20, className = "", ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 37 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path d="M29.2543 5.92629L27.4361 1L25.6057 5.92629L20.6794 7.75676L25.6057 9.57494L27.4361 14.5012L29.2543 9.57494L34.1806 7.75676L29.2543 5.92629Z"
                  fill="currentColor"/>
            <path d="M19.4017 21.8722H10.8022V24.3292H19.4017V21.8722Z" fill="currentColor"/>
            <path d="M23.0872 12.0442H10.8022V14.5012H23.0872V12.0442Z" fill="currentColor"/>
            <path d="M23.0872 16.9582H10.8022V19.4152H23.0872V16.9582Z" fill="currentColor"/>
            <path d="M26.6376 16.9582V28.2236H7.25184V8.83783H18.5172V6.0737H7.25184C6.49017 6.0737 5.83906 6.34397 5.29852 6.88451C5.26167 6.92137 5.22481 6.97051 5.18796 7.01965C5.12653 7.09336 5.06511 7.15478 5.00369 7.22849C4.79484 7.51105 4.64742 7.81817 4.57371 8.14987C4.57371 8.16215 4.57371 8.17444 4.57371 8.18672C4.52457 8.39557 4.5 8.60441 4.5 8.83783V28.2236C4.5 28.6904 4.62285 29.1204 4.8317 29.5135C4.95455 29.7469 5.11425 29.9803 5.32309 30.1892C5.86363 30.7297 6.51474 31 7.27641 31H26.6622C27.4238 31 28.0749 30.7297 28.6155 30.1892C28.8243 29.9803 28.9717 29.7592 29.1069 29.5135C29.3157 29.1204 29.4386 28.7027 29.4386 28.2236V16.9582H26.6744H26.6376Z"
                  fill="currentColor"/>

        </svg>

    )
}